import Link from 'next/link';

import { type Account, type WorkspaceInfo } from '@air/api/types';
import { AirIcon } from '@air/design-icons';
import {
  ContentCollectionAccountInformation,
  ContentCollectionPageHeader,
  ContentCollectionWorkspaceInformation,
} from '@air/feature-content-collection/ui';

import { PublicSignUpButton } from '~/components/PublicSignUpButton';
import { Routes } from '~/constants/routes';
import { BOARD_COLLECTION_HERO, PUBLIC_TOP_BAR_LOGO } from '~/constants/testIDs';

export type ContentCollectionHeroProps = {
  workspace: Pick<WorkspaceInfo, 'name' | 'image'>;
  account: Pick<Account, 'email' | 'firstName' | 'lastName'> | undefined;
};

export const ContentCollectionHero = ({ workspace, account }: ContentCollectionHeroProps) => (
  <ContentCollectionPageHeader data-testid={BOARD_COLLECTION_HERO}>
    <ContentCollectionWorkspaceInformation workspace={workspace} />
    <div className="flex items-center gap-6">
      {account ? <ContentCollectionAccountInformation account={account} /> : <PublicSignUpButton />}
      <Link href={Routes.root}>
        <AirIcon className="text-black dark:text-white" data-testid={PUBLIC_TOP_BAR_LOGO} size={48} />
      </Link>
    </div>
  </ContentCollectionPageHeader>
);
